import apiClient from '@u/apiClient'
import GetCompanyPaymentSyncOverviewController from '@/wayfinder/actions/App/Http/Controllers/Partner/ChiftAccounting/GetCompanyPaymentSyncOverviewController'
import UpdateCompanyChiftInvoicingPaymentSyncController from '@/wayfinder/actions/App/Http/Controllers/Partner/ChiftInvoicing/UpdateCompanyChiftInvoicingPaymentSyncController'
import RunCompanyPaymentSyncController from '@/wayfinder/actions/App/Http/Controllers/Partner/ChiftAccounting/RunCompanyPaymentSyncController'
import GetPaymentSyncRunController from '@/wayfinder/actions/App/Http/Controllers/Partner/ChiftAccounting/GetPaymentSyncRunController'
import GetCompanyConsumerController from '@/wayfinder/actions/App/Http/Controllers/Chift/GetCompanyConsumerController'
import CreateCompanyConsumerController from '@/wayfinder/actions/App/Http/Controllers/Chift/CreateCompanyConsumerController'
import SearchCustomerInChiftAccountingController from '@/wayfinder/actions/App/Http/Controllers/Company/SearchCustomerInChiftAccountingController'
import DeleteCompanyConsumerController from '@/wayfinder/actions/App/Http/Controllers/Chift/DeleteCompanyConsumerController'
import GetCompanyIntegrationsListController from '@/wayfinder/actions/App/Http/Controllers/Chift/GetCompanyIntegrationsListController'
import CreateCompanyConnexionController from '@/wayfinder/actions/App/Http/Controllers/Chift/CreateCompanyConnexionController'
import SyncCompanyAccountingCode from '@/wayfinder/actions/App/Http/Controllers/Chift/SyncCompanyAccountingCode'
import GetCompanyConnexionMetadata from '@/wayfinder/actions/App/Http/Controllers/Chift/GetCompanyConnexionMetadata'
import DeleteCompanyConnexionController from '@/wayfinder/actions/App/Http/Controllers/Chift/DeleteCompanyConnexionController'

export default {
  getCompanyPaymentSyncOverview({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetCompanyPaymentSyncOverviewController.get({ company: payload.id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  runCompanyPaymentSync({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(RunCompanyPaymentSyncController.post({ company: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateCompanyChiftInvoicingPaymentSync({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateCompanyChiftInvoicingPaymentSyncController.put({
            company: payload.id
          }),
          {
            enabled: payload.enabled
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getPaymentSyncRun({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetPaymentSyncRunController.get({ payment_sync_run: payload.id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getCompanyChiftConsumer({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetCompanyConsumerController.get({ company: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  createCompanyChiftConsumer({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CreateCompanyConsumerController.post({ company: payload.id }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  searchCustomerInChiftAccounting({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          SearchCustomerInChiftAccountingController.get({
            company: payload.id
          }),
          {
            params: payload.params
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  deleteCompanyChiftConsumer({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteCompanyConsumerController.delete({ company: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getCompanyChiftIntegrationsList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetCompanyIntegrationsListController.get({ company: payload.id }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  addConnexionToConsumer({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CreateCompanyConnexionController.post({ company: payload.id }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  syncAccountingCode({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(SyncCompanyAccountingCode.get({ company: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getCompanyChiftConnexionMetadata({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetCompanyConnexionMetadata.get({ company: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  deleteCompanyChiftConnexion({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteCompanyConnexionController.delete({
            company: payload.id,
            connexion_id: payload.connexion_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
